const session = require('@flowio/session');
const find = require('lodash/find');
const filter = require('lodash/filter');
const assign = require('lodash/assign');

const LocalizedVariantStore = function LocalizedVariantStoreConstructor() {
  this.store = [];
};
/**
 * Add a variant to the store.
 * @param {object}  localizedVariant The variant to add
 * @param {object}  opts
 * @param {boolean} opts.overwrite   Replace existing variants with the one
 *                                   provided.
 */
LocalizedVariantStore.prototype.addVariant =
  function addVariant(localizedVariant, opts) {
    const options = assign({ overwrite: false }, opts);

    if (!localizedVariant) {
      throw new Error('localizedVariant must be defined');
    }

    if (!localizedVariant.experience || !localizedVariant.experience.key) {
      throw new Error('localizedVariant must have an experience');
    }

    const existing = this.getByIdAndExperience(
      localizedVariant.id,
      localizedVariant.experience.key,
    );

    if (options.overwrite) {
      // remove variant w/ same experience if it exists
      this.store = filter(this.store, variant =>
        !(variant.experience.key === localizedVariant.experience.key &&
          variant.id === localizedVariant.id));
      this.store.push(localizedVariant);
    } else if (!existing) {
      this.store.push(localizedVariant);
    }
  };

LocalizedVariantStore.prototype.getByIdAndExperience =
  function getByIdAndExperience(variantId, experience) {
    if (!variantId) {
      return undefined;
    }

    return find(this.store, variant =>
      variant.id.toString() === variantId.toString()
        && variant.experience.key === experience);
  };

LocalizedVariantStore.prototype.getByHandleAndExperience =
  function getByHandleAndExperience(handle, experience) {
    if (!handle) {
      return [];
    }

    return filter(this.store, variant =>
      variant.handle.toString() === handle.toString()
        && variant.experience.key === experience);
  };

LocalizedVariantStore.prototype.getById = function getById(variantId) {
  if (!variantId) {
    return undefined;
  }

  const experience = session.getExperience();

  if (!experience) {
    return undefined;
  }

  return this.getByIdAndExperience(variantId, experience);
};

LocalizedVariantStore.prototype.getByHandle = function getByHandle(handle) {
  if (!handle) {
    return [];
  }

  const experience = session.getExperience();

  if (!experience) {
    return [];
  }

  return this.getByHandleAndExperience(handle, experience);
};

LocalizedVariantStore.prototype.clear = function clear() {
  this.store = [];
};

module.exports = LocalizedVariantStore;



// WEBPACK FOOTER //
// ./static/js/v0/cache/localized-variant-store.js